/**
* @module index
* @author: liuxinyu
* @description: 
* @since: 2020-07-09 16:04:41
*/
import React, { Component } from 'react';
import RegisterBox from './RegisterBox/index';
import LoginBox from './LoginBox/index';
import { message } from 'antd';
import { getLoginConfig, setLogin, getFrontUserCode, openThirdlogin } from '@/fetch/api/token.js';
import './style.less';
export class LoginRegister extends Component {
  state = {
    tabList: [{
      title: '登录',
      checked: true
    }, {
      title: '注册',
      checked: false
    }],
    loginConfig: null,
    currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev-s.yunduoketang.cn/'
  };

  componentDidMount() {
    getLoginConfig().then(res => {
      if (res.code == '1') {
        this.setState({
          loginConfig: res.data
        });
      }
    });
  }

  changeTab(index) {
    document.getElementsByClassName('header-active')[index].classList.add('active');

    if (index == 0) {
      document.getElementsByClassName('register-box')[0].style.display = 'none';
      document.getElementsByClassName('login-box')[0].style.display = 'block';
      document.getElementsByClassName('header-active')[1] && document.getElementsByClassName('header-active')[1].classList.remove('active');
    } else {
      document.getElementsByClassName('login-box')[0].style.display = 'none';
      document.getElementsByClassName('register-box')[0].style.display = 'block';
      document.getElementsByClassName('header-active')[0].classList.remove('active');
    }

    let {
      tabList
    } = this.state;
    tabList.forEach(item => item.checked = false);
    tabList[index].checked = true;
    this.setState({
      tabList
    });
  }

  deleteLoginBox = () => {
    document.getElementById('loginRegisterBox').style.display = 'none';
    this.setState({
      tabList: [{
        title: '登录',
        checked: true
      }, {
        title: '注册',
        checked: false
      }]
    });
  };
  handlethirdLogin = type => {
    var windowOpen,
        left,
        top,
        width = 666,
        height = 565,
        screenHeight = document.body.clientHeight,
        screenWidth = document.body.clientWidth;
    left = (screenWidth - width) / 2;
    top = screenHeight - height + 60;
    windowOpen = window.open('', 'lingyired', 'status=no,menubar=no,titlebar=no,toolbar=no,directories=no, width=' + width + ',height=' + height + ', top=' + top + ', left=' + left);
    this.windowOpen = windowOpen;
    if (!windowOpen || typeof windowOpen == 'undefined') message.warning('窗口无法打开，请检查你的浏览器设置。');
    openThirdlogin({
      domain: this.state.currentDomain,
      type
    }).then(res => {
      if (res && res.flag) {
        if (windowOpen) windowOpen.location.href = res.url; //监听消息反馈

        window.addEventListener('message', function (event) {
          // 未做event.origin的验证，通过token验证
          if (event.data.indexOf('_') == -1) {
            return;
          }

          var userId = event.data.split('_')[0];
          var token = event.data.split('_')[1];
          window.location.href = "/thirdLogin/user/login/" + userId + "?token=" + token;
        }, false);
      } else {
        windowOpen && windowOpen.close();
      }
    });
  };

  render() {
    let {
      tabList,
      loginConfig
    } = this.state;
    let {
      registerConfig
    } = this.props; // console.log(this.props.registerConfig, 'this.props.registerConfigthis.props.registerConfig');

    return <div data-inspector-line="97" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="login-register-mask" id="loginRegisterBox">
        <div data-inspector-line="98" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="login-register-box">
          <i data-inspector-line="99" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="iconfont iconguanbi close" onClick={this.deleteLoginBox}></i>
          <div data-inspector-line="100" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="login-reg-header" style={{
          width: registerConfig && registerConfig.closeFlag == 0 ? '' : '44px'
        }}>
            <div data-inspector-line="101" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="header-active" onClick={this.changeTab.bind(this, 0)}>
              登录
            </div>
            {registerConfig && registerConfig.closeFlag == 0 ? <div data-inspector-line="107" data-inspector-column="64" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="header-active" onClick={this.changeTab.bind(this, 1)}>
                注册
            </div> : null}
          </div>
          <div data-inspector-line="114" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="login-reg-section">
            <LoginBox data-inspector-line="115" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" loginConfig={loginConfig} />
            <RegisterBox data-inspector-line="116" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" loginConfig={loginConfig} registerConfig={this.props.registerConfig} />
            {loginConfig && loginConfig.thirdLoginFlag == 1 && (loginConfig.wechatLogin == 1 || loginConfig.qqLogin == 1 || loginConfig.weiboLogin == 1 || loginConfig.wechatWorkLogin == 1 && loginConfig.wechatWorkRegLogin == 1) ? <div data-inspector-line="119" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="login-type">
                  {loginConfig.wechatLogin == 1 ? <i data-inspector-line="120" data-inspector-column="50" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="iconfont iconweixin" onClick={this.handlethirdLogin.bind(this, 'weixin')}></i> : null}
                  {loginConfig.qqLogin == 1 ? <i data-inspector-line="121" data-inspector-column="46" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="iconfont iconQQ" onClick={this.handlethirdLogin.bind(this, 'qq')}></i> : null}
                  {loginConfig.weiboLogin == 1 ? <i data-inspector-line="122" data-inspector-column="49" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="iconfont iconweibo" onClick={this.handlethirdLogin.bind(this, 'weibo')}></i> : null}
                  {loginConfig.wechatWorkLogin == 1 && loginConfig.wechatWorkRegLogin == 1 ? <i data-inspector-line="123" data-inspector-column="93" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\index.jsx" className="iconfont iconqiyeweixin" onClick={this.handlethirdLogin.bind(this, 'weixinwork')}></i> : null}
                </div> : null}
          </div>
        </div>
      </div>;
  }

}
export default LoginRegister;